import { action } from "satcheljs";
import { IShiftEntity } from "sh-models";
import { ShiftStoreTypes } from "sh-application/../StaffHubConstants";
import { IPreviewSchedulePageStore } from "../../../sh-application/components/previewSchedulePage";
import { SchedulesViewStateStore } from "../../../sh-application/components/schedules/lib/store/schema/SchedulesViewStateStore";

const updateShiftsV2 = action(
    "UPDATE_SHIFTS_V2",
    (
        shiftsUpdated: IShiftEntity[],
        isOptimisticUpdate: boolean,
        shiftStoreType: ShiftStoreTypes,
        viewStates?: Array<IPreviewSchedulePageStore | SchedulesViewStateStore>
    ) => ({
        shiftsUpdated: shiftsUpdated || [],
        isOptimisticUpdate: isOptimisticUpdate,
        shiftStoreType: shiftStoreType,
        viewStates: viewStates || []
    })
);

export default updateShiftsV2;